<template>
  <header class="header">
    <div class="container">
      <a class="avatar" href="//www.cargotransworld.com/">
        <el-image class="img" :src="logoUrl" alt="华运昌供应链"></el-image>
      </a>
      <ul class="topbar-nav">
        <li><a @click="go('First')">首页</a></li>
        <li><a @click="go('Regard')">关于我们</a></li>
        <li><a @click="go('Services')">服务范围</a></li>
        <li><a @click="newPage(memberLoginUrl)">会员注册</a></li>
        <li><a @click="newPage(memberUrl)">系统平台</a></li>
        <li><a @click="go('Newcenter')">新闻中心</a></li>
        <li><a @click="go('Contact')">联系我们</a></li>
      </ul>
    </div>
  </header>
</template>

<script>
import { myMixin } from '../../mixin'

export default {
  name: 'Header',
  mixins: [myMixin],
  data() {
    return {
      disabled: true,
      memberLoginUrl: 'http://39.108.216.104:5001/#/register',
      memberUrl: 'http://39.108.216.104:5001',
      logoUrl: require('@/assets/images/logo/logo.png')
    }
  }
}
</script>

<style scoped>
a {
  color: #ffffff;
}

.header {
  height: 100px;
  background-color: rgba(37, 37, 37, 0.5);
}

.avatar {
}

.avatar > .img {
  vertical-align: middle;
}

.topbar-nav {
  height: 100%;
  line-height: 100px;
  display: flex;
  text-align: center;
}

.topbar-nav > li {
  cursor: pointer;
  margin: 0 5px;
  height: 100%;
}

.topbar-nav > li > a {
  height: 100px;
  width: 80px;
  font-size: 18px;
  display: block;
}

.topbar-nav > li > a:hover {
  background-color: rgb(225, 171, 63);
}

.disabled {
  pointer-events: none;
  color: #cccccc;
}

.container {
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1180px;
  height: 100%;
}
</style>
